import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloakAuth } from '../../../contexts/KeycloakAuthProvider';
import { useHeaderTranslation } from '../../../modules/i18n';

import { LightIcon, DarkIcon, DarkModeIcon, LogoutIcon, SettingsIcon } from '../HeaderIcons';
import { MenuItem, SubMenuItem } from '../../../types';

export const useHeaderMenuItems = (isDarkMode: boolean, toggleDarkMode: () => void, setIsSettingsOpen: (open: boolean) => void) => {
  const { t } = useHeaderTranslation();
  const navigate = useNavigate();
  const { logout } = useKeycloakAuth();

  const themeSubmenuItems: SubMenuItem[] = [
    {
      icon: React.createElement(LightIcon),
      label: t('theme.light'),
      action: () => (!isDarkMode ? null : toggleDarkMode()),
      isActive: !isDarkMode
    },
    {
      icon: React.createElement(DarkIcon),
      label: t('theme.dark'),
      action: () => (isDarkMode ? null : toggleDarkMode()),
      isActive: isDarkMode
    }
  ];

  const desktopMenuItems: MenuItem[] = [
    {
      id: 'theme',
      icon: React.createElement(DarkModeIcon, { isDarkMode }),
      label: isDarkMode ? t('theme.dark') : t('theme.light'),
      action: () => {},
      hasSubmenu: true,
      submenuItems: themeSubmenuItems
    },
    {
      id: 'settings',
      icon: React.createElement(SettingsIcon),
      label: t('menu.settings'),
      action: () => {
        navigate('/settings');
        setIsSettingsOpen(false);
      },
      hasSubmenu: false
    },
    {
      id: 'logout',
      icon: React.createElement(LogoutIcon),
      label: t('menu.logout'),
      action: logout,
      hasSubmenu: false
    }
  ];

  const mobileMenuItems: MenuItem[] = [
    {
      id: 'light-mode',
      icon: React.createElement(LightIcon),
      label: t('theme.light'),
      action: () => (!isDarkMode ? null : toggleDarkMode()),
      isActive: !isDarkMode
    },
    {
      id: 'dark-mode',
      icon: React.createElement(DarkIcon),
      label: t('theme.dark'),
      action: () => (isDarkMode ? null : toggleDarkMode()),
      isActive: isDarkMode
    },
    {
      id: 'settings',
      icon: React.createElement(SettingsIcon),
      label: t('menu.settings'),
      action: () => {
        navigate('/settings');
        setIsSettingsOpen(false);
      },
      isActive: false
    },
    {
      id: 'logout',
      icon: React.createElement(LogoutIcon),
      label: t('menu.logout'),
      action: () => logout(),
      isActive: false
    }
  ];

  return {
    desktopMenuItems,
    mobileMenuItems
  };
};
